import { hasClass, checkNull } from '@/helpers'
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'


export default {
    name: 'profile-list-with-carousel',
    data() {
        return {
            swiper_options: {
                preventClicks: false,
                preventClicksPropagation: false,
                slidesPerView: 'auto',
                loop: true,
                loopedSlides: 5,
                spaceBetween: 10
            }
        }
    },
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    props: {
        title: {
            type: String,
            default: 'Profiles'
        },
        profiles: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    computed: {
        swiper() {
            return (this.$refs.carousel) ? this.$refs.carousel.$swiper : null
        }
    },
    methods: {
        checkNull,
        sliderClicked(event) {
            let slide = event.target.closest('.swiper-slide')
            if(hasClass(slide, 'swiper-slide-duplicate')) {
                let i_index = slide.getAttribute('data-swiper-slide-index')
                let item = this.$refs['profile-thumb'][i_index]
                
                if(checkNull(item)) {
                    if(hasClass(event.target, 'favorite')) {
                        if(hasClass(event.target, 'fa-heart-o')) {
                            event.target.className = 'favorite fa fa-heart'
                        } else {
                            event.target.className = 'favorite fa fa-heart-o'
                        }
                    }
                    if(hasClass(event.target, 'message')) item.goToChat()
                    if(hasClass(event.target, 'image')) item.goToProfile()
                }
            }
        },
        slideChange() {
            // temporary fix for blank images on loop (from duplicate slides)
            if(this.swiper.activeIndex-1 === this.profiles.length) {
                this.swiper.slideTo(5, 100)
            }
            // for reverse 
            if(this.swiper.realIndex > this.profiles.length-5) {
                this.swiper.slideTo(this.profiles.length, 100)
            }
        },
        clickedSlider(event) {
            console.log(event)
        },
        slidePrev() {
            if(checkNull(this.swiper)) this.swiper.slidePrev()
        },
        slideNext() {
            if(checkNull(this.swiper)) this.swiper.slideNext()
        },
    }
}